import * as types from "./partner.actionTypes";
import { action, createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { PartnerUpdate, PartnerRequest } from "../../interfaces/Partner";
import { PartnerCreateResponse, PartnerDetailResponse, PartnerListResponse, PartnerUpdateResponse } from "./types";
import { Negara } from "../../interfaces/Negara";
import { JenisLembaga } from "../../interfaces/JenisLembaga";

export const selectPartner = (partner: PartnerRequest | null) => action(types.SELECT_PARTNER, { partner });

export const updateName = (value: string) => action(types.UPDATE_NAME, { value });
export const updateAddress = (value: string) => action(types.UPDATE_ADDRESS, {value});
export const updateWebsite = (value: string) => action(types.UPDATE_WEBSITE, {value});
export const updatePhone = (value: string) => action(types.UPDATE_PHONE, {value});
export const updateCity = (value: string) => action(types.UPDATE_CITY, {value});
export const updatePostCode = (value: string) => action(types.UPDATE_POSTCODE, {value});
export const updateCountry = (newId: string, newDetail: Negara) => action(types.UPDATE_COUNTRY, { newId, newDetail });
export const updateType = (newId: number, newDetail: JenisLembaga) => action(types.UPDATE_TYPE, { newId, newDetail });
export const updatePicName = (value: string) => action(types.UPDATE_PIC_NAME, {value});
export const updatePicEmail = (value: string) => action(types.UPDATE_PIC_EMAIL, {value});
export const updatePicPhone = (value: string) => action(types.UPDATE_PIC_PHONE, {value});
export const updatePicPosition = (value: string) => action(types.UPDATE_PIC_POSITION, {value});
export const updatePicDepartment = (value: string) => action(types.UPDATE_PIC_DEPARTMENT, {value});

export const initializeCreatePartner = () => {
  const partner: PartnerUpdate | null = {
    CO_ID: 0,
    CO_NAME: '',
    CO_ALAMAT: '',
    CO_WEB: '',
    CO_TELP: '',
    CO_KOTA: '',
    CO_KODEPOS: '',
    CO_PIC_NAME: '',
    CO_PIC_EMAIL: '',
    CO_PIC_PHONE: '',
    CO_PIC_JOB_TITLE: '',
    CO_PIC_DEPT: '',
    CO_NEGARA_ID: '',
    CO_TYP_ID: ''
  }

  return action(types.INITIALIZE_CREATE_PARTNER, { partner })
}

export const getPartnerAsync = createAsyncAction(
  types.GET_PARTNER_REQUEST,
  types.GET_PARTNER_SUCCESS,
  types.GET_PARTNER_FAILURE
)<undefined, PartnerListResponse, ErrorResponse>();

export const getDetailPartnerAsync = createAsyncAction(
  types.GET_DETAIL_PARTNER_REQUEST,
  types.GET_DETAIL_PARTNER_SUCCESS,
  types.GET_DETAIL_PARTNER_FAILURE
)<{ id: number }, PartnerDetailResponse, ErrorResponse>();

export const updatePartnerAsync = createAsyncAction(
  types.UPDATE_PARTNER_REQUEST,
  types.UPDATE_PARTNER_SUCCESS,
  types.UPDATE_PARTNER_FAILURE
)<PartnerUpdate, PartnerUpdateResponse, ErrorResponse>();

export const createPartnerAsync = createAsyncAction(
  types.CREATE_PARTNER_REQUEST,
  types.CREATE_PARTNER_SUCCESS,
  types.CREATE_PARTNER_FAILURE
)<PartnerUpdate, PartnerCreateResponse, ErrorResponse>();
